import React from "react";
import Draggable from "react-draggable";
import { connect } from "react-redux";
import { getWindowsProps } from "../utils/helpers";
import { updateIndex, closeWindow, showPhotographiesWindow } from "../actions";

class PostitWindow extends React.Component {
  render() {
    const postitData = getWindowsProps(
      this.props.windows.windowsData,
      "Postit"
    );

    const windowStyle = {
      position: "absolute",
      top: postitData.position.top,
      left: postitData.position.left,
      zIndex: postitData.z
    };

    const windowsWidth = {
      width: postitData.width
    };

    return (
      <Draggable
        bounds="body"
        onMouseDown={() => this.props.updateIndex(postitData)}
      >
        <div style={windowStyle} className={postitData.show ? "" : "hidden"}>
          <div className="work400" style={windowsWidth}>
            <div className="postit-container">
              <div className="header"></div>
              <p>Currently looking around for cool projects.</p>
            </div>
          </div>
        </div>
      </Draggable>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

export default connect(
  mapStateToProps,
  { updateIndex, closeWindow, showPhotographiesWindow }
)(PostitWindow);
